module.exports = __webpack_public_path__ + "img/floorThr.940458ad.png";